import angular from 'angular';
import { config } from './member.privileges.config';
import MemberPrivileges from './member.privileges.component';
export default angular.module('invision.customercare.customer.memberPrivileges', []).config(config).component('memberPrivileges', MemberPrivileges).name;